import { Group, List } from '@mantine/core';
import React, { useEffect } from 'react';
import SequentialNumber from '../../../Organismns/Settings/SequentialNumber';
import { RoutingS } from '../../../Service/RoutingS';
import BookitupAlert from '../../../Atoms/BookitupAlert';
import { IconBulb } from '@tabler/icons';

const SequentialNumbers = () => {
  useEffect(() => {
    RoutingS.changeTitle('Buchhaltung');
  }, []);

  return (
    <>
      <Group>
        <BookitupAlert title="Platzhalter einfügen" icon={<IconBulb />} style={{ maxWidth: 470 }}>
          Um automatisch z.B. das aktuelle Jahr einzufügen oder eine fortlaufende Nummer, kannst du mit der "#"-Taste
          folgende <b>Platzhalter einfügen</b>.
          <br />
          <br />
          <List spacing={5} size="xs">
            <List.Item>Aktuelles Jahr</List.Item>
            <List.Item>Aktueller Monat</List.Item>
            <List.Item>Aktueller Monat 2-stellig</List.Item>
            <List.Item>Aktueller Tag</List.Item>
            <List.Item>Fortlaufende Nummer</List.Item>
          </List>
        </BookitupAlert>
        <SequentialNumber sequentialNumberType="CONTRACT_NUMBER" />
        <SequentialNumber sequentialNumberType="OFFER_NUMBER" />
        <SequentialNumber sequentialNumberType="CONFIRMATION_NUMBER" />
        <SequentialNumber sequentialNumberType="INVOICE_NUMBER" />
        <SequentialNumber sequentialNumberType="DELIVERY_NOTE_NUMBER" />
        <SequentialNumber sequentialNumberType="PACKING_LIST_NUMBER" />
        <SequentialNumber sequentialNumberType="CANCEL_NUMBER" />
      </Group>
    </>
  );
};

export default SequentialNumbers;
